function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Component, Fragment } from "react";
import Container from "./components/Container";
import Item from "./components/Item";
import { toggleSelectedItem } from "./components/util/toggleSelectedItem";
import { pageBuilder } from "./components/util/pageBuilder";
var Pagination = function(Component1) {
    "use strict";
    _inherits(Pagination, Component1);
    var _super = _createSuper(Pagination);
    function Pagination() {
        _classCallCheck(this, Pagination);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selected: undefined,
            controlled: false
        };
        _this.toggleItem = function(index) {
            var selected;
            if (_this.state.controlled) {
                selected = toggleSelectedItem(index, _this.props.selected);
            } else {
                selected = toggleSelectedItem(index, _this.state.selected);
                _this.setState({
                    selected: selected
                });
            }
            _this.props.onChange(selected);
        };
        return _this;
    }
    var _proto = Pagination.prototype;
    _proto.render = function render() {
        var _props = this.props, accessibilityLabel = _props.accessibilityLabel, accessible = _props.accessible, isRtl = _props.isRtl, testID = _props.testID, totalPages = _props.totalPages, hideNumbers = _props.hideNumbers;
        var selected = (this.state.controlled ? this.props : this.state).selected;
        return _jsx(Container, {
            accessible: accessible,
            accessibilityLabel: accessibilityLabel,
            isRtl: isRtl,
            testID: testID,
            children: _jsxs(Fragment, {
                children: [
                    this.renderIconButton('left', selected, totalPages),
                    !hideNumbers && this.renderItems(selected, totalPages),
                    this.renderIconButton('right', selected, totalPages)
                ]
            })
        });
    };
    _proto.renderItems = function renderItems(selected, totalPages) {
        var _this = this;
        if (typeof selected === 'undefined' || typeof totalPages === 'undefined') {
            return [];
        }
        var pageChildrenArray = pageBuilder({
            selected: selected,
            totalPages: totalPages
        });
        return React.Children.map(pageChildrenArray, function(element) {
            var _this1 = _this;
            return React.cloneElement(element, {
                isRtl: _this.props.isRtl,
                accessible: _this.props.accessible,
                onPress: function(e) {
                    _this1.toggleItem(Number(element.props.text));
                    if (element.props.onPress) {
                        element.props.onPress(e);
                    }
                }
            });
        });
    };
    _proto.renderIconButton = function renderIconButton(direction, selected, totalPages) {
        var _this = this;
        if (typeof selected === 'undefined') {
            return null;
        }
        return _jsx(Item, {
            isRtl: this.props.isRtl,
            accessibilityLabel: direction === 'left' ? this.props.accessibilityLabelPrevButton : this.props.accessibilityLabelNextButton,
            icon: direction,
            disabled: selected === 1 && direction === 'left' || selected === totalPages && direction === 'right',
            onPress: function(e) {
                _this.toggleItem(direction === 'left' ? selected - 1 : selected + 1);
                if (_this.props.onPress) {
                    _this.props.onPress(e);
                }
            }
        });
    };
    Pagination.getDerivedStateFromProps = function getDerivedStateFromProps(param, state) {
        var defaultSelected = param.defaultSelected, selected = param.selected;
        return _objectSpread({}, state, {
            selected: state.selected !== undefined ? state.selected : defaultSelected,
            controlled: selected !== undefined
        });
    };
    return Pagination;
}(Component);
Pagination.defaultProps = {
    accessibilityLabel: '',
    accessible: true,
    isRtl: false,
    selected: undefined,
    defaultSelected: 1,
    totalPages: 1,
    accessibilityLabelPrevButton: 'Previous Page',
    accessibilityLabelNextButton: 'Next Page',
    hideNumbers: false
};
export { Pagination as default };
